import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/motion";
import { FOUNDERS } from "@/data/site";
import { Linkedin, MapPin } from "lucide-react";

export default function Founders() {
  return (
    <section data-testid="founders" className="bg-white py-8">
      <div className="nc-container">
        <SectionHeading
          align="center"
          eyebrow="Meet the Co-Founders"
          title={<>The people behind <span className="text-[#142A5E]">North Cadence.</span></>}
          subtitle="Two co-founders. Combined experience spanning global enterprise sales, IT staffing and consulting, healthcare SaaS, and AI product leadership. One shared commitment to clients."
        />

        <div className="mt-16 grid gap-8 lg:grid-cols-2">
          {FOUNDERS.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.1}>
              <div
                data-testid={`founder-${f.name.toLowerCase().split(" ")[0]}`}
                className="group h-full rounded-3xl border border-[#e7e9ef] bg-[#FEF7F2] p-7"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-display text-2xl font-bold text-[#1B1B1B]">{f.name}</h3>
                    <p className="mt-1.5 flex items-center gap-1.5 text-sm leading-snug text-[#1B1B1B]/60">
                      {f.role} <span className="text-[#1B1B1B]/30">·</span>
                      <span className="flex items-center gap-1">
                        <MapPin className="h-3.5 w-3.5 shrink-0" /> {f.location}
                      </span>
                    </p>
                  </div>
                  {f.linkedin && (
                    <a
                      href={f.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#142A5E]/20 text-[#142A5E] transition-colors hover:bg-[#142A5E] hover:text-white"
                      aria-label={`${f.name} on LinkedIn`}
                    >
                      <Linkedin className="h-4 w-4" />
                    </a>
                  )}
                </div>

                <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-[#1B1B1B]/65">
                  <p>{f.bio}</p>
                  <p>{f.bioExtra}</p>
                  <p>{f.handles}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
